/**
 * baseConf
 *
 * Created by Samuel on 2022/10/1
 */
import {language} from "@/env";

const SUPPORT_LANGUAGES = ['cn', 'en', 'fr', 'ja', 'ko', 'tw'];

const publicPath = process.env.NODE_ENV !== 'production' ? '' : '';

export const config = {
	supportedLanguage: (language) => {
        return 'en';
        // todo 暂时支持en
		// if (!SUPPORT_LANGUAGES.includes(language)) {
		// 	return 'en';
		// }
		// return language;
	},
	localesPath: publicPath + '/locales',
	language,
	changeLanguage(langId) {},
};
